import React, { Component } from "react";
import HeaderTwo from "../../components/HeaderTwo";

import FooterTwo from "../../components/FooterTwo";
import { Styles } from "./styles/franchise";

import PrivacyPolicyBox from "../../components/PrivacyPolicy";
import HelpCenterBox from "../../components/HelpCenter";

const HelpCenter = () => {
  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper about-page">
        {/* Header 2 */}
        <HeaderTwo />

        {/* Tab Section */}
        <HelpCenterBox heading={'General Information'} />

        {/* Footer 2 */}
        <FooterTwo />
      </div>
    </Styles>
  );
};

export default HelpCenter;
